'use client'

import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn } from '@/lib/classMerge'
import { useIsMobile } from '@/hooks/use-mobile'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipArrow = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Arrow>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Arrow>
>(({ className, ...props }, ref) => (
  <TooltipPrimitive.Arrow
    ref={ref}
    width={14}
    height={7}
    className={className}
    {...props}
  />
))
TooltipArrow.displayName = TooltipPrimitive.Arrow.displayName

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    variant?: 'default' | 'custom'
    sideOffset?: number
    className?: string
  }
>(({ className, sideOffset = 4, variant = 'default', ...props }, ref) => {
  const isMobile = useIsMobile()

  return (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      onPointerDown={isMobile ? e => e.preventDefault() : undefined}
      className={cn(
        variant === 'default'
          ? 'z-50 overflow-hidden rounded-md border border-gray-200 bg-[#1C1C1C] px-4 py-2.5 text-base text-white animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2'
          : 'font-inter relative z-50 h-auto w-auto max-w-[350px] rounded-[6px] border border-gray-200 bg-[#1C1C1C] px-4 py-3 text-[16px] font-normal leading-[24px] text-white animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    >
      {props.children}
      <TooltipArrow
        className={cn(
          className?.includes('bg-white') ? 'fill-white' : 'fill-[#353A41]'
        )}
      />
    </TooltipPrimitive.Content>
  )
})
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipArrow
}
